export const CvScoringEnglish = {
  cvScore: 'CV Score: {score}',
  match: 'Match: {match}',
  matchGood: 'Good match',
  matchBest: 'Best match',
  matchWeak: 'Weak match',
  tooltipContent: 'This AI-generated score may not be an accurate reflection of the candidate. Please review candidate carefully.',
  criteriaNotAdded: 'Criteria not added',
  scoreNotGenerated: 'Score not generated',
  criteriaMissing: 'Unable to generate the CV score because criteria have not been added for this job.',
  criteriaOutdated: 'Score is outdated because the job criteria have been updated.',
  limitRestriction: 'AI is unable to generate the CV score for this application due to the 500 limit restriction.',
  cvMissing: 'Unable to generate the CV score because the CV file is missing.',
  scoringFailed: 'Unable to generate the CV score.',
  scoringInProgress: 'Score is being generated, it may take a few minutes.',
  refreshButton: 'Click here to refresh',
  reGenerateCriteria: 'Re-generate score',
  addCriteriaButton: 'Add Criteria',
  generateScoreButton: 'Generate score',
  retryButton: 'Retry',
  viewDetailsButton: 'View details',
  bulkGenerateScoreTitle: 'Bulk Generate Score ({selectedCount})',
  generateScoresText: 'This will generate scores for the {selectedCount} selected candidates based on the job criteria.',
  generateScoresTextWithCredits: 'Only {canBeParsed} out of {totalSelected} CVs can be scored due to limited AI scoring and parsing credits.',
  noteText: 'Note: Generating scores may take a few minutes.',
  generateScoreButtonText: 'Generate score ({selectedCount})',
  scoringInProgressText: 'CV scoring is in progress. This may take a few minutes.',
  aiScoringTitle: 'AI Scoring',
  regenerateCvScoreMessage: 'Cv Score regeneration started successfully',
  inSufficientCredits: 'Unable to generate the CV score because you’ve run out of AI Parsing and Scoring credits.',
  addMoreCredits: 'Add more credits'
}

export const CvScoringArabic = {
  cvScore: 'نتيجة السيرة الذاتية: {score}',
  match: 'التوافق: {match}',
  matchGood: 'تطابق جيد',
  matchBest: 'أفضل تطابق',
  matchWeak: 'تطابق ضعيف',
  tooltipContent: 'قد لا يكون هذا التقييم المُولد بواسطة الذكاء الاصطناعي انعكاسًا دقيقًا للمرشح. يرجى مراجعة المرشح بعناية.',
  criteriaNotAdded: 'لم تتم إضافة المعايير',
  scoreNotGenerated: 'لم يتم توليد النتيجة',
  criteriaMissing: 'تعذر توليد التقييم للسيرة الذاتية لأن المعايير لم تتم إضافتها لهذه الوظيفة.',
  criteriaOutdated: 'التقييم قديم لأن معايير الوظيفة تم تحديثها.',
  limitRestriction: 'لا يمكن للذكاء الاصطناعي توليد نتيجة السيرة الذاتية لهذا التطبيق بسبب قيود الحد الأقصى 500.',
  cvMissing: 'تعذر توليد التقييم للسيرة الذاتية لأن ملف السيرة الذاتية مفقود.',
  scoringFailed: 'تعذر توليد التقييم للسيرة الذاتية.',
  scoringInProgress: 'يتم توليد التقييم، قد يستغرق ذلك بضع دقائق.',
  refreshButton: 'انقر هنا للتحديث',
  addCriteriaButton: 'إضافة معايير',
  generateScoreButton: 'توليد التقييم',
  retryButton: 'أعد المحاولة لتوليد النتيجة لهذا التطبيق',
  viewDetailsButton: 'عرض التفاصيل',
  reGenerateCriteria: 'إعادة توليد التقييم',
  bulkGenerateScoreTitle: 'توليد التقييم بالجملة ({selectedCount})',
  generateScoresText: 'سيتم توليد التقييمات لـ {selectedCount} مرشحاً تم اختيارهم بناءً على معايير الوظيفة.',
  generateScoresTextWithCredits: 'يمكن تقييم {canBeParsed} فقط من أصل {totalSelected} من السير الذاتية بسبب محدودية أرصدة تحليل وتقييم الذكاء الاصطناعي.',
  noteText: 'ملاحظة: قد يستغرق توليد التقييمات بضع دقائق.',
  generateScoreButtonText: 'توليد التقييم ({selectedCount})',
  scoringInProgressText: 'جاري توليد التقييم للسير الذاتية. قد يستغرق ذلك بضع دقائق.',
  aiScoringTitle: 'التقييم باستخدام الذكاء الاصطناعي',
  regenerateCvScoreMessage: 'تم بدء إعادة توليد التقييم للسيرة الذاتية بنجاح',
  inSufficientCredits: 'تعذر توليد درجة السيرة الذاتية لأنك نفدت الائتمانات الخاصة بتحليل وتقييم الذكاء الاصطناعي.',
  addMoreCredits: 'إضافة المزيد من الائتمانات'
}
